"use client"

import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet"
import { useIsMobile } from "@/hooks/use-mobile"

import { PersonProfileContent } from "./person-profile-content"

type PersonProfileSheetProps = {
  personId: string | null
  isOpen: boolean
  onClose: () => void
}

export function PersonProfileSheet({ personId, isOpen, onClose }: PersonProfileSheetProps) {
  const isMobile = useIsMobile()
  const open = isOpen && Boolean(personId)

  return (
    <Sheet
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose()
      }}
    >
      <SheetContent
        side={isMobile ? "bottom" : "right"}
        className={[
          "flex h-[94vh] flex-col gap-0 overflow-visible border bg-background p-0",
          isMobile
            ? "inset-x-0 bottom-0 rounded-t-[28px] border-x-0 border-b-0"
            : "h-screen rounded-none border-y-0 border-r-0 border-l shadow-2xl sm:max-w-none",
        ].join(" ")}
        style={isMobile ? undefined : { width: "760px", maxWidth: "95vw" }}
      >
        <SheetTitle className="sr-only">Person profile</SheetTitle>
        {personId && (
          <PersonProfileContent
            personId={personId}
            className="h-full min-h-0 overflow-y-auto p-4 pr-12 sm:p-6 sm:pr-14"
          />
        )}
      </SheetContent>
    </Sheet>
  )
}
